import React, { PureComponent } from 'react';
import { getImageFileName } from '../../../utils';

interface IImageProps {
  imageName: string;
  altText: string;
  className?: string[];
  dynamic?: boolean;
}

interface IImageState {
  src: string;
}

export default class Image extends PureComponent<IImageProps, IImageState> {
  private imageRef: React.MutableRefObject<HTMLImageElement>;

  constructor(props: IImageProps) {
    super(props);
    this.state = {
      src: require(`../../../assets/${this.props.imageName}`)
    };
    this.imageRef = React.createRef();
  }

  componentDidMount() {
    const isPrerendered = window.__PRERENDER_INJECTED !== undefined;
    const imageFileName =
      this.props.dynamic && getImageFileName(this.props.imageName);

    const src =
      this.props.dynamic && !isPrerendered
        ? window.dynamicImages[imageFileName]
        : this.imageRef.current.getAttribute('src');

    if (src.indexOf('$staticlink$') === -1 && src.indexOf('http') !== -1) {
      this.setState({ src });
    }
  }

  render() {
    const { altText, className } = this.props;
    const { src } = this.state;
    return (
      <img
        className={className && className.join(' ')}
        ref={this.imageRef}
        src={src}
        alt={altText}
      />
    );
  }
}
